import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';
import * as yup from 'yup';

import { NestedFields } from '@/components/molecules/NestedFields';
import { Field } from '@/types/fields';
import { isObjectKindOrUndefined } from '@/utility/isObjectKind';

interface Props<T> {
  readonly title?: string;
  readonly fields: ReadonlyArray<Field<T>>;
  readonly columnsCount: number;
  readonly errors?: Record<string, yup.ValidationError>;
  readonly required?: boolean;
  readonly defaultValue?: unknown;
}

export function EmbeddedFormFieldElement<T>(props: Props<T>): React.ReactElement {
  const { fields, title, errors, columnsCount, defaultValue } = props;

  if (!isObjectKindOrUndefined(defaultValue)) {
    throw new Error('EmbeddedField expects defaultValue to be an object');
  }

  return (
    <Box>
      {title && (
        <Box mb={2}>
          <Typography variant="subtitle1">{title}</Typography>
        </Box>
      )}

      <NestedFields
        fields={fields}
        errors={errors}
        columnsCount={columnsCount}
        defaultValue={defaultValue}
      />
    </Box>
  );
}
